/**
 * Formatos de cable: lo que viaja en JSON. Un único lugar define cómo se serializa
 * el dominio para que front y back no diverjan (SSOT S1).
 */
import { z } from 'zod';
import type { Permission } from './roles.js';

/** Un permiso en el cable es un string `resource:action`. */
export const PermissionSchemaWire = z.custom<Permission>(
  (v) => typeof v === 'string' && /^[a-z_]+:[a-z_]+$/.test(v),
  { message: 'Permiso inválido' },
);

/** Envelope genérico de error ya está en errors.ts (Problem). */
export const ApiErrorEnvelope = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
  }),
});
export type ApiErrorEnvelope = z.infer<typeof ApiErrorEnvelope>;
